import { render, staticRenderFns } from "./mobileGameDown.vue?vue&type=template&id=fce70ebc&scoped=true&"
import script from "./mobileGameDown.vue?vue&type=script&lang=js&"
export * from "./mobileGameDown.vue?vue&type=script&lang=js&"
import style0 from "./mobileGameDown.vue?vue&type=style&index=0&id=fce70ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce70ebc",
  null
  
)

export default component.exports